import { makeStyles } from 'tss-react/mui';
import React, { useCallback } from 'react';
// @ts-ignore
import { translate } from "../../../base/i18n";
import { useTranslation } from "react-i18next";
const useStyles = makeStyles()(() => {
    return {
        container: {
            marginRight: '5px'
        },
        label: {
            display: 'inline-flex',
            alignItems: 'center',
            gap: '0.2rem',
            cursor: 'pointer',
            color: 'white',
        },
        checkBox: {
            appearance: 'none',
            cursor: 'pointer',
            '&:before': {
                content: '""',
                display: 'inline-block',
                width: '15px',
                height: '15px',
                border: '1px solid #6f9c63',
                borderRadius: '4px',
                verticalAlign: 'middle'
            },
            '&:checked': {
                backgroundColor: '#6f9c63',
                borderColor: '#6f9c63',
                borderRadius: '4px',
                '&:before': {
                    content: '""',
                    backgroundColor: '#6f9c63',
                    borderColor: '#6f9c63',
                    borderRadius: '4px',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: '50%'
                }
            },
            '&:disabled': {
                cursor: 'not-allowed',
                backgroundColor: 'none',
                borderColor: 'gray',
                borderRadius: '4px',
                '&:before': {
                    content: '""',
                    borderColor: 'gray',
                    backgroundColor: 'none',
                    borderRadius: '4px',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: '50%'
                },
                '+span': {
                    cursor: 'not-allowed',
                    color: 'gray'
                }
            }
        },
        title: {
            marginLeft: 5,
            marginBottom: 5,
            color: '#fff',
            fontWeight: 'bold'
        }
    };
});
const ToggleMath = React.forwardRef(({ checked, onChange, disabled, id }, ref) => {
    const handleChange = useCallback((e) => onChange(e.target.value), []);
    const { classes: styles } = useStyles();
    const { t } = useTranslation();
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: styles.container },
            React.createElement("p", { className: styles.title }, t("chat.mathmode")),
            React.createElement("label", { className: styles.label },
                React.createElement("input", { id: id, checked: checked, className: styles.checkBox, disabled: disabled, onChange: handleChange, type: 'checkbox' }),
                React.createElement("span", null, t("chat.math"))))));
});
export default translate(ToggleMath);
